export const READ_PROJECTS_LIST = 'PROJECT_READ_LIST';
export const READ_PROJECT = 'READ';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const ARCHIVE_DAVINCI_OBJECT = 'COMPANY_ARCHIVE_DAVINCI_OBJECT';
